import React from 'react';
import { Link } from 'react-router';
import { PageHero } from '../components/PageHero';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import useTheme from '../hooks/useTheme';

export const NotFound: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <>
      <PageHero
        title="404 - Page Not Found"
        subtitle="The page you're looking for doesn't exist or has been moved."
      />

      <Section>
        <Card style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 700,
              color: theme.palette.primary.main,
              marginBottom: '16px',
            }}
          >
            404
          </h2>
          <p
            style={{
              fontSize: '18px',
              color: theme.text.muted,
              marginBottom: '32px',
              lineHeight: 1.6,
            }}
          >
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button variant="primary">Return to Home</Button>
          </Link>
        </Card>
      </Section>
    </>
  );
};

